import { AlertTriangle } from 'lucide-react';

/**
 * ContentWarning — gate shown before the chain renders if the lesson carries
 * sensitive content tags. Copy is plain, source-aware, and explains why TSOGN
 * acknowledges difficult material rather than redacting it.
 */
export default function ContentWarning({ warnings, onProceed }) {
  if (!warnings || warnings.length === 0) return null;
  return (
    <div className="p-6 flex items-center justify-center" data-testid="content-warning">
      <div
        className="max-w-md text-center border border-[#D4A84A]/20 rounded-lg p-6"
        style={{ background: '#0A0A0A' }}
      >
        <AlertTriangle className="mx-auto text-[#D4A84A] mb-3" size={28} />
        <h3 className="font-historical text-[#D4A84A] text-lg mb-2">Content Notice</h3>
        <div className="space-y-2 mb-4">
          {warnings.map((w, i) => (
            <p key={i} className="font-mono text-xs text-white/80">{w}</p>
          ))}
        </div>
        <p className="font-mono text-[9px] text-[#52525B] mb-4">
          TSOGN acknowledges historical reality and cites primary sources. Graphic content is not reproduced.
          Source citations allow researchers access to unredacted material.
        </p>
        <button
          data-testid="content-warning-proceed"
          onClick={onProceed}
          className="font-hud text-xs tracking-wider text-[#0A0A0A] bg-[#D4A84A] px-6 py-2 hover:bg-[#D4A84A]/80 transition-all duration-300"
        >
          I UNDERSTAND — CONTINUE
        </button>
      </div>
    </div>
  );
}
